export default __webpack_public_path__ + "static/media/nicknamebg.6e4fc017.png";